import { render, staticRenderFns } from "./business-list.vue?vue&type=template&id=3740b9fe&scoped=true&"
import script from "./business-list.vue?vue&type=script&lang=js&"
export * from "./business-list.vue?vue&type=script&lang=js&"
import style0 from "./business-list.vue?vue&type=style&index=0&id=3740b9fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3740b9fe",
  null
  
)

export default component.exports